<div class="page-wrapper">
	<div class="main-layout">
		<div class="main-content">
			<div *ngIf="isFeatureEnabled('USOfficialWebsiteBanner')">
				<us-official-banner></us-official-banner>
			</div>
			<div *ngIf="isFeatureEnabled('BrandBanner')">
				<brand-banner></brand-banner>
			</div>
			<div class="navcontent">
				<navigation></navigation>
			</div>
			<div class="content">
				<user-profile></user-profile>
			</div>
			<kv-footer></kv-footer>
		</div>
	</div>
</div>